import { BrowserRouter } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { AuthProvider } from 'shared/contexts/AuthContext';
import { AppRoutes } from 'routes/AppRoutes';
import { ToastProvider } from 'shared/components/ui/Toast';
import { ArenaProfileProvider } from 'shared/contexts/ArenaProfileContext';

function App() {
  return (
    // reducedMotion="user": quem pede menos movimento no sistema operacional vê as telas sem animação.
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <AuthProvider>
          <ArenaProfileProvider>
            <ToastProvider>
              <AppRoutes />
            </ToastProvider>
          </ArenaProfileProvider>
        </AuthProvider>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
